export default {
  catQuizResults: [],
  rewardType: '',
};
